// extracted by mini-css-extract-plugin
export default {"cover_card":"Carousel_cover_card__6Ulq1","cover_caption":"Carousel_cover_caption__i+n+A","cover_thumb":"Carousel_cover_thumb__YUG8z","mobile_drag":"Carousel_mobile_drag__1riZ2"};